var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrench",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8104 5.25037C10.8104 5.05405 10.8873 4.86557 11.0248 4.72537L13.355 2.39662C13.5957 2.15512 13.5192 1.74862 13.1908 1.65862C12.3666 1.43202 11.4949 1.44482 10.6778 1.69554C9.86066 1.94625 9.13182 2.4245 8.57657 3.07433C8.02132 3.72416 7.66262 4.51868 7.54245 5.36493C7.42228 6.21118 7.54561 7.07415 7.898 7.85287L1.9655 13.7854C1.66713 14.0836 1.49947 14.4882 1.4994 14.9101C1.49933 15.332 1.66686 15.7366 1.96513 16.035C2.26339 16.3334 2.66797 16.501 3.08986 16.5011C3.51175 16.5012 3.91638 16.3336 4.21475 16.0354L10.1473 10.1029C10.926 10.4553 11.7889 10.5786 12.6352 10.4584C13.4814 10.3382 14.276 9.97955 14.9258 9.4243C15.5756 8.86905 16.0539 8.14021 16.3046 7.32306C16.5553 6.50592 16.5681 5.63427 16.3415 4.81012C16.2515 4.48162 15.8443 4.40512 15.6043 4.64662L13.2748 6.97537C13.1346 7.11279 12.9461 7.18976 12.7498 7.18976C12.5534 7.18976 12.3649 7.11279 12.2247 6.97537L11.0248 5.77537C10.8873 5.63517 10.8104 5.44668 10.8104 5.25037Z",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.8660f3d3ca9923c775689695dca41650.svg";
export { ForwardRef as ReactComponent };